import React from 'react';
import { Route } from 'react-router-dom';
import SlideRoutes from 'react-slide-routes';
import ArticleListPage from './ArticleList/ArticleListPage';
import { useAppContext } from '@front-activerse/common-components';
import { IRoute } from '@front-activerse/common-components';

interface IKnowledgePage {
  descendantRoutes: IRoute[];
  articlesPerPage: number;
  truncateLimit: number;
  categories: string[];
  categoryAsNumber: { [key: string]: number };
}

const Knowledge: React.FC<IKnowledgePage> = ({
  descendantRoutes,
  articlesPerPage,
  truncateLimit,
  categories,
  categoryAsNumber,
}) => {
  const {
    consts: { SLIDE_ROUTES_DURATION },
  } = useAppContext();

  const renderRoutes = (): any => {
    return descendantRoutes.map((route) => {
      return <Route key={route.path} path={route.path} element={route.element} />;
    });
  };

  return (
    <SlideRoutes duration={+SLIDE_ROUTES_DURATION} destroy={false}>
      <Route
        path="/"
        element={
          <ArticleListPage
            consts={{ articlesPerPage, truncateLimit, categories, categoryAsNumber }}
          />
        }
      />
      {renderRoutes()}
    </SlideRoutes>
  );
};

export default Knowledge;
